import { client } from "./supabase";

export const getActivos = async (pais, filters = {}) => {
  let query = client
    .from("activos")
    .select(
      `
      *,
      proveedor:proveedores(id, nombre, alias),
      factura_sii:facturas_sii_recibidas(id, folio, razon_social_emisor)
    `
    )
    .eq("pais", pais)
    .eq("eliminado", false)
    .order("fecha_compra", { ascending: false });

  if (filters.estado) query = query.eq("estado", filters.estado);
  if (filters.destino_tipo) query = query.eq("destino_tipo", filters.destino_tipo);
  if (filters.destino_id) query = query.eq("destino_id", filters.destino_id);
  if (filters.proyecto_nombre) query = query.eq("proyecto_nombre", filters.proyecto_nombre);

  const { data, error } = await query;
  if (error) throw error;
  return data || [];
};

export const crearActivo = async (activo) => {
  const { data, error } = await client
    .from("activos")
    .insert({ ...activo, eliminado: false })
    .select()
    .single();
  if (error) throw error;
  return data;
};

export const actualizarActivo = async (id, cambios) => {
  const { data, error } = await client
    .from("activos")
    .update({ ...cambios, updated_at: new Date().toISOString() })
    .eq("id", id)
    .select()
    .single();
  if (error) throw error;
  return data;
};

export const eliminarActivo = async (id) => {
  const { error } = await client
    .from("activos")
    .update({ eliminado: true, updated_at: new Date().toISOString() })
    .eq("id", id);
  if (error) throw error;
};

export const getActivosPlanificados = async (pais) => getActivos(pais, { estado: "planificado" });

export const getActivosPorDestino = async (pais, destino_tipo, destino_id) =>
  getActivos(pais, { destino_tipo, destino_id });

export const getActivosPorProyecto = async (pais, proyecto_nombre) => getActivos(pais, { proyecto_nombre });
